import { post } from "../lib/apiHelpers";
import { baseURL } from "./tanzib";
import { AdtraceEventType } from "src/types/api/analytics.types";

//Posting for adtrace events
export function adtraceEvent(data: AdtraceEventType) {
  return post(`${baseURL}/adtrace/event`, data);
}
